module.exports = __webpack_public_path__ + "img/logo_wx.7414d3de.jpg";